<template>
  <Row>
    <Row type="flex" justify="end" style="margin:12px 0;">
      <Page
        :current="page.current"
        show-total
        :total="page.total"
        size="small"
        @on-change="changePage"
        show-sizer
        :page-size="page.limit"
        @on-page-size-change="changeLimit"
        :page-size-opts="[10, 20, 30, 40, 50, 60, 80]"
      ></Page>
      <i-button size="small" @click="downloadByColumns">
        <FFIcon type="download" aria-hidden="true" /> download
      </i-button>
    </Row>

    <Row>
      <i-table
        size="small"
        :data="dataset"
        :columns="columns"
        @on-sort-change="sortTable"
      ></i-table>
    </Row>

    <Row type="flex" justify="end" style="margin:12px 0;">
      <Page
        :current="page.current"
        show-total
        :total="page.total"
        size="small"
        @on-change="changePage"
        show-sizer
        :page-size="page.limit"
        @on-page-size-change="changeLimit"
        :page-size-opts="[10, 20, 30, 40, 50, 60, 80]"
      ></Page>
      <i-button size="small" @click="downloadByColumns">
        <FFIcon type="download" aria-hidden="true" /> download
      </i-button>
    </Row>
  </Row>
</template>

<script>
import tableActions from "@/mixins/table_actions.js";
import pagination from "@/mixins/pagination.js";
import sort from "@/mixins/sort.js";
import { getGeoEntityByISO3 } from "@/models/GeoEntity.ts";

export default {
  mixins: [tableActions, pagination, sort],
  props: ["conditions", "limit", "table"],

  data() {
    return {
      tableURL: this.table || "documents_view",
      dataset: [],
    };
  },

  computed: {
    columns() {
      return [
        // ----- ID
        // {
        //   title: "ID",
        //   key: "id",
        //   width: 120
        // },
        // ----- Serial No.
        {
          title: "GSN",
          key: "gsn",
          width: 140,
        },
        // ----- Name
        {
          title: "Name",
          key: "name",
          sortable: "custom",
          sortType: this.sort.name || "normal",
          width: 520,
          render: (h, params) =>
            h("div", [
              h(
                "router-link",
                { attrs: { to: "/documents/" + params.row.id } },
                [h("span", params.row.name)]
              ),
            ]),
        },
        // ----- Publication Date
        {
          title: "Publication Date",
          key: "publication_date",
          width: 180,
          sortable: "custom",
          sortType: this.sort.publication_date || "normal",
        },
        // ----- Countries
        {
          title: "Countries",
          key: "countries",
          width: 480,
          render: countriesColumnRender,
        },
        // ----- Publishers
        {
          title: "Publishers",
          key: "publisher",
          width: 480,
          render: publishersColumnRender,
        },
        // ----- Sources
        {
          title: "Sources",
          key: "sources",
          width: 480,
          render: sourcesColumnRender,
        },
      ];
    },
  },

  created() {
    this.sort["publication_date"] = "desc";
    this.load();
  },
  watch: {
    conditions() {
      this.load();
    },
    table() {
      this.tableURL = this.table;
      this.load();
    },
  },
  methods: {
    downloadByColumns() {
      this.download(
        "id,gsn,name,publication_date,geo_names,publishers_names,sources_names"
      );
    },
  },
};

function sourcesColumnRender(h, params) {
  if (params.row.sources !== null && params.row.sources.length > 0) {
    let tags = [];
    for (let source of params.row.sources) {
      let name = source.name;
      let geo_name = source.geo_name ? ` / ${source.geo_name}` : ``;
      tags.push(h("Tag", name + geo_name));
    }
    return h("div", tags);
  }
  return h("div");
}

function publishersColumnRender(h, params) {
  if (params.row.publishers !== null && params.row.publishers.length > 0) {
    let tags = [];
    for (let publisher of params.row.publishers) {
      let name = publisher.name;
      let geo_name = publisher.geo_name ? ` / ${publisher.geo_name}` : ``;
      tags.push(h("Tag", name + geo_name));
    }
    return h("div", tags);
  }
  return h("div");
}

// function countriesColumnRender(h, params) {
//   if (params.row.countries !== null && params.row.countries.length > 0) {
//     let tags = [];
//     for (let i = 0; i < params.row.countries.length; i++) {
//       tags.push(h("Tag", params.row.countries[i]));
//     }
//     return h("div", tags);
//   }
//   return h("div");
// }

function countriesColumnRender(h, params) {
  if (params.row.countries !== null && params.row.countries.length > 0) {
    let tags = [];
    // for (let i = 0; i < params.row.countries.length; i++) {
    //   const countryName = getGeoEntityByISO3(params.row.countries[i]).name;
    //   tags.push(h("Tag", countryName));
    // }
    for (let country of params.row.countries) {
      const countryName = getGeoEntityByISO3(country).name;
      tags.push(h("Tag", countryName));
    }
    return h("div", tags);
  }
  return h("div");
}
</script>

<style lang="css">
.ivu-table-small td {
  height: 32px;
}
</style>
